// extracted by mini-css-extract-plugin
export default {"podiumContainer":"Podium_podiumContainer__8ilOu","podiumStep":"Podium_podiumStep__w0ekm","winnerName":"Podium_winnerName__YTebj"};